var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C5.81855 0 0 5.81855 0 13C0 20.1815 5.81855 26 13 26C20.1815 26 26 20.1815 26 13C26 5.81855 20.1815 0 13 0ZM19.0282 8.84314C18.8343 10.898 17.9851 15.8883 17.5552 18.1895C17.3718 19.1645 17.0153 19.4895 16.6694 19.521C15.9145 19.5891 15.3431 19.023 14.6093 18.5407C13.4665 17.7911 12.8165 17.3246 11.7105 16.5907C10.4262 15.7468 11.2597 15.2802 11.9883 14.5202C12.1823 14.321 15.5056 11.2964 15.5685 11.0238C15.579 10.9871 15.5843 10.8613 15.5056 10.7931C15.427 10.725 15.3169 10.7512 15.2383 10.7669C15.123 10.7914 13.2953 11.9988 9.75524 14.3891C9.23804 14.7456 8.76801 14.9185 8.34516 14.9081C7.87863 14.8976 6.9875 14.646 6.32177 14.431C5.50927 14.169 4.85927 14.0274 4.91694 13.5766C4.94489 13.3425 5.26815 13.1031 5.88669 12.8585C9.67487 11.209 12.2015 10.1204 13.4665 9.59274C17.0782 8.09355 17.8278 7.83145 18.3153 7.82097C18.4254 7.82097 18.6613 7.84718 18.8185 7.97298C18.9212 8.06322 18.9866 8.18841 19.002 8.32419C19.0304 8.49563 19.0392 8.66973 19.0282 8.84314Z",
    fill: "#2AC0CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.8c01efa9913eebbc3ea6d9c3b86d0987.svg";
export { ForwardRef as ReactComponent };